import { call, put, takeEvery } from "redux-saga/effects";
import service from "services/menuService";
import { getMenuSuccess } from "./actions";
// Login Redux States
import { GET_MENU } from "./actionTypes";

function* getMenu() {
  try {
    console.log("getMenu");
    const response = yield call(service.getMenu);
    yield put(getMenuSuccess(response));
  } catch (error) {}
}

function* menuSaga() {
  yield takeEvery(GET_MENU, getMenu);
}

export default menuSaga;
